"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StayInformed() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="262831" id="stay-informed" className="bg-secondary py-[var(--spacing-header-padding-token)]">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-12">
          <div className="md:w-[60%]">
            <h2 className="text-3xl md:text-[32px] font-default font-bold text-foreground leading-tight">
              Stay Informed with the Latest Cybersecurity Insights and UAE Compliance Updates.
            </h2>
          </div>
          <div className="md:w-[40%] flex md:justify-end">
            <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-white rounded-md px-8 h-14 text-lg font-default font-semibold border-0 shadow-md transition-transform hover:scale-105">
              <Link to="/ContactUsPage">
                Request a Consultation
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}